import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter,
  ElementRef,
} from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { SharedService } from "../shared-service.service";
import { CampaignService } from "src/app/_services/campaign.service";
import {
  CampaignStatus,
  EmailPreference,
  ICampaign,
  ICampaignStage,
} from "src/app/model/campaign";
import { EmailIntegrationService } from "src/app/_services/email-integration.service";
import { EmailsettingsService } from "src/app/_services/emailsettings.service";
import { LocalStorageService } from "src/app/_services/local-storage.service";
import { Router } from "@angular/router";
import { GlobalService } from "src/app/_services/global.service";
import * as moment from "moment";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { map } from "rxjs/operators";
import { EmailCampaignAssistantComponent, EmailCampaignAssistantData } from "src/app/openai/email-campaign-assistant/email-campaign-assistant.component";
import { EmailCampaignService, CampaignStagePrompt } from "../email-campaign.service";

const notOnlyWhitespace = (control: FormControl) => {
  if (control.value?.includes("<p>")) {
    let temp = control.value;
    temp = temp.split(" ").join("");
    temp = temp.split("<p>").join("");
    temp = temp.split("</p>").join("");
    if (temp.length === 0) return { notOnlyWhitespace: true };
  } else if (control.value && control.value.trim().length === 0) {
    return { notOnlyWhitespace: true };
  }
  return null;
};
@Component({
  selector: "app-edit-panel",
  templateUrl: "./edit-panel.component.html",
  styleUrls: ["./edit-panel.component.scss"],
})
export class EditPanelComponent implements OnInit {
  stageFormGroup: FormGroup = new FormGroup({
    stepName: new FormControl(null, [Validators.required, notOnlyWhitespace]),
    emailTemplate: new FormControl(null),
    to: new FormControl(null, [Validators.required]),
    from: new FormControl(null, [Validators.required]),
    subject: new FormControl(null, [Validators.required, notOnlyWhitespace]),
    body: new FormControl(null, [Validators.required, notOnlyWhitespace]), //FIXME: add candidate name on candidate's place
    campaignId: new FormControl(null),
    regularDays: new FormControl(true),
    schedule: new FormGroup({
      startTime: new FormControl(null, [
        (control: FormControl) => {
          if (!this.stageFormGroup) {
            return null;
          }
          return this.performDateValidation(
            moment().format("YYYY-MM-DD"),
            control.value,
            this.stageFormGroup.get("schedule")?.value.endTime
          );
        },
      ]),
      endTime: new FormControl(null, [
        (control: FormControl) => {
          if (!this.stageFormGroup) {
            return null;
          }
          return this.performDateValidation(
            moment().format("YYYY-MM-DD"),
            this.stageFormGroup.get("schedule")?.value.startTime,
            control.value
          );
        },
      ]),
      timezone: new FormControl(
        Intl.DateTimeFormat().resolvedOptions().timeZone
      ),
    }),
    after_minutes: new FormControl(moment.duration(1, "d").asMinutes(), [
      Validators.required,
      Validators.min(1),
    ]),
    placeholder: new FormControl(null),
    isUnsubscribed: new FormControl(true)
  });

  @Input() campaign_details: any = {};
  // Dropdown options
  emailTemplates: string[] = ["Template 1", "Template 2", "Template 3"];
  toOptions: string[] = [
    "Personal Email Only",
    "Professional Email Only",
    "First Look For Personal Then Professional",
    "First Look For Professional Then Personal",
  ];
  displayBanner: boolean = true;
  integratedemailsarray: any[] = [];
  templates: string[];
  timezones: string[];
  @Input() availableStages: any;
  customtempList: [];
  InputtoEdit: any;
  sel: Selection;
  range: Range;
  placeid: boolean;
  placeholderlist = GlobalService.placeholderlist;
  dropDownValue: any;
  modalData: { templateName } = { templateName: "" };
  bodyEditor: any;
  modalRef: NgbModalRef;
  @ViewChild("createTemplateModal") createTemplateModal: TemplateRef<NgbModalRef>;

  @ViewChild("testMailConfirmation") testMailConfirmation: TemplateRef<HTMLDivElement>;
  errorMessage: string;
  successMessage: string;
  activeStage: number = 0;
  afterDays: number = 1;
  selectedEmail: string = "";
  @Input() stage: ICampaignStage;
  @Input() stages: ICampaignStage[] = [];
  @Output() isEditMode: EventEmitter<{}> = new EventEmitter<{
    stageId: null;
    editMode: false;
  }>();
  isEditing: boolean = false;
  @Output() updatedStage: EventEmitter<ICampaignStage> =
    new EventEmitter<ICampaignStage>();
  @Input() isInEditMode: { stageId; editMode };
  @Output() deleteStep: EventEmitter<number> = new EventEmitter<number>();
  @Input() prevStageId: number;
  @Output() updatedCampaign: EventEmitter<ICampaign> =
    new EventEmitter<ICampaign>();
  saveAsTemplate: boolean = false;
  @ViewChild("subject") subject: ElementRef;

  composeType: 'AI' | 'MANUAL' = 'AI';

  showAIAssist: boolean = true;

  aiPromptData: EmailCampaignAssistantData;
  /**Text of unsubscribe written in mail body */
  UnsubscribeTextEmailBody: string = `<p> <a href='{{unsubscriptionUrl}}'>Click here to Unsubscribe </a> </p>`;

  private _isSendingTestEmail: boolean = false;
  public testEmailSent: boolean = false;

  get isSendingTestEmail(): boolean {
    return this._isSendingTestEmail;
  }

  constructor(
    private fb: FormBuilder,
    private sharedService: SharedService,
    private campaignService: CampaignService,
    private emailintegrationservice: EmailIntegrationService,
    private emailsettings: EmailsettingsService,
    private _localstorageservice: LocalStorageService,
    private router: Router,
    private modalService: NgbModal,
    private readonly emailCampaignService: EmailCampaignService
  ) {
    // this.createForms();
  }
  setInstance(args) {
    this.bodyEditor = args.editor;
  }

  get isDisable(){
    return (this.campaign_details?.status !== 3);
  }

  ngOnInit() {
    this.fetchIntegration();
    this.getEmailTemplate();
    //@ts-ignore
    this.timezones = Intl.supportedValuesOf("timeZone");
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.stage) {
      const unsubscribeCheckboxFormControl = this.stageFormGroup.get('isUnsubscribed');
      const stage = changes.stage.currentValue;
      this.populatePromptData();
      if (stage && stage?.stage_name && stage?.stage_name.length) {
        this.displayBanner = false;
        this.stageFormGroup.patchValue({
          stepName: this.stage.stage_name,
          emailTemplate: null,
          to: this.campaign_details["email_pref"],
          from:
            this.campaign_details &&
            this.campaign_details["useremailintegrationid"]
              ? this.campaign_details["useremailintegrationid"]
              : null,
          subject: this.stage["subject"] || this.stages[0]?.subject,
          body: this.stage["body"],
          after_minutes: moment.duration(stage.after_minutes, "m").asDays(),
          regularDays: stage.regular_days,
          schedule: {
            startTime:
              this.campaign_details.schedule &&
              this.campaign_details.schedule.length &&
              !this.campaign_details.schedule.includes("null")
                ? this.campaign_details.schedule.split("-")[0]
                : "10:00",
            endTime:
              this.campaign_details.schedule &&
              this.campaign_details.schedule.length &&
              !this.campaign_details.schedule.includes("null")
                ? this.campaign_details.schedule.split("-")[1]
                : "17:00",
            timezone: this.campaign_details["timezone"],

          },
          isUnsubscribed: stage['isUnsubscribed']
        });
        this.isDisable && unsubscribeCheckboxFormControl.disable({ onlySelf: true });

        if (!stage.after_id) {
          this.stageFormGroup.patchValue({
            // from:this.integratedemailsarray[this.campaign_details['useremailintegrationid']]['emailid'],
            campaignId: this.campaign_details["campaign_id"],
            to: this.campaign_details["email_pref"],
            schedule: {
              startTime:
                this.campaign_details.schedule &&
                this.campaign_details.schedule.length &&
                !this.campaign_details.schedule.includes("null")
                  ? this.campaign_details.schedule.split("-")[0]
                  : "10:00",
              endTime:
                this.campaign_details.schedule &&
                this.campaign_details.schedule.length &&
                !this.campaign_details.schedule.includes("null")
                  ? this.campaign_details.schedule.split("-")[1]
                  : "17:00",
              timezone: this.campaign_details["timezone"],
            },
            regularDays: stage.regular_days,
          });
          this.stageFormGroup.get("after_minutes").clearValidators();
          this.stageFormGroup.get("after_minutes").updateValueAndValidity();
        }
        if (stage?.after_id) {
          this.displayBanner = false;
          this.afterDays = moment.duration(stage.after_minutes, "m").asDays();
          this.stageFormGroup.patchValue({
            after_minutes: moment
              .duration(stage.after_minutes ? stage.after_minutes : 1440, "m")
              .days(),
            schedule: {
              startTime:
                this.campaign_details.schedule &&
                this.campaign_details.schedule.length &&
                !this.campaign_details.schedule.includes("null")
                  ? this.campaign_details.schedule.split("-")[0]
                  : "10:00",
              endTime:
                this.campaign_details.schedule &&
                this.campaign_details.schedule.length &&
                !this.campaign_details.schedule.includes("null")
                  ? this.campaign_details.schedule.split("-")[1]
                  : "17:00",
              timezone: this.campaign_details["timezone"],
            },
            to: this.campaign_details["email_pref"],
          });
          //set Validator for after_minutes after_minutes min value should be 1
          this.stageFormGroup
            .get("after_minutes")
            .setValidators([Validators.required, Validators.min(1)]);
          this.stageFormGroup.get("after_minutes").updateValueAndValidity();
        }
        if (this.stage){
          if (this.stage.body) {
            this.composeManually();
          } else {
            this.composeAI();
          }
        }
      } // process from data
      this.resetForm();
    }
    if (changes.campaign_details) {
      const currentDetails = changes.campaign_details.currentValue;
      this.stageFormGroup.patchValue({
        to: currentDetails["email_pref"],
        schedule: {
          startTime:
            currentDetails.schedule &&
            currentDetails.schedule.length &&
            !currentDetails.schedule.includes("null")
              ? currentDetails.schedule.split("-")[0]
              : "10:00",
          endTime:
            currentDetails.schedule &&
            currentDetails.schedule.length &&
            !currentDetails.schedule.includes("null")
              ? currentDetails.schedule.split("-")[1]
              : "17:00",
          timezone: currentDetails["timezone"],
        },
      });
    }
  }

  populatePromptData() {
    if (this.stage && this.stage.campaign_stage_id) {
      this.emailCampaignService
        .getCampaignStagePrompt(this.campaign_details.campaign_id, this.stage.campaign_stage_id)
        .subscribe((res) => {
          if (res.status === "success") {
            const prompt = res.data[0];
            if (!prompt) {
              this.aiPromptData.id = null;
              this.aiPromptData.prompt_id = null;
              this.aiPromptData.response = null;
              return;
            }
            const promptData: EmailCampaignAssistantData = {} as EmailCampaignAssistantData;
            promptData.prompt_id = prompt.prompt_id;
            promptData.tone = prompt.tone;
            promptData.id = prompt.campaign_stage_prompt_id;
            promptData.promptType = prompt.prompt_input === 'JD' ? 'JD' : 'Role';
            if (prompt.prompt_input === 'JD') {
              promptData.jd = prompt.prompt_value;
            } else {
              promptData.role = prompt.prompt_value;
            }
            this.aiPromptData = promptData;
          }
        });
    }
  }

  onCancel() {
    if (!this.stage.after_id && !this.stage.campaign_stage_id) {
      this.displayBanner = true;
      this.isEditMode.emit({ stageId: null, editMode: false });
      this.deleteStep.emit(-1);
    } else if (this.stage.campaign_stage_id) {
      this.setEditMode();
    } else {
      this.deleteStep.emit(-1);
    }
    this.stageFormGroup.patchValue({
      //fill every key by null
      stepName: this.stage.stage_name,
      // emailTemplate: null,
      to: this.campaign_details.email_pref,
      subject: this.stage.subject,
      body: this.stage.body,
      after_minutes: this.stage.after_minutes,
      campaignId: this.campaign_details.campaign_id,
      regularDays: this.stage.regular_days,
      schedule: {
        startTime:
          this.campaign_details.schedule &&
          this.campaign_details.schedule.length &&
          !this.campaign_details.schedule.includes("null")
            ? this.campaign_details.schedule.split("-")[0]
            : "10:00",
        endTime:
          this.campaign_details.schedule &&
          this.campaign_details.schedule.length &&
          !this.campaign_details.schedule.includes("null")
            ? this.campaign_details.schedule.split("-")[1]
            : "17:00",
        timezone:
          this.campaign_details &&
          this.campaign_details.length &&
          this.campaign_details.timezone
            ? this.campaign_details["timezone"]
            : "Asia/Calcutta",
      },
      placeholder: null,
      from: this.campaign_details.useremailintegrationid,
    });
    // this.stageFormGroup.setErrors(null);
    // this.stageFormGroup.markAsUntouched()
    this.resetForm();
    // this.router.navigate(['email-campaign/target-listing/'+ this.campaign_details['campaign_id']])
  }
  updateEmailStepName(value: string) {
    this.sharedService.updateEmailStepName(value);
  }
  onSaveForm1() {
    this.stageFormGroup.markAllAsTouched();
    if (!this.stageFormGroup.invalid) {
      if (this.stage && this.stage.campaign_stage_id) {
        this.updateCampaignStage(this.campaign_details["campaign_id"]);
      } else {
        this.createEmailCampaignStage();
      }
      this.updateCampaign(this.campaign_details["status"]);

      //TODO: implement save template
      if (this.saveAsTemplate) {
        this.modalRef = this.modalService.open(this.createTemplateModal, {
          size: "xs" as "lg",
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
    // this.isEditMode2 = true;
  }
  getEmailPreferenceValue(option: string): EmailPreference | null {
    switch (option) {
      case "Personal Email Only":
        return EmailPreference.Personal;
      case "Professional Email Only":
        return EmailPreference.Professional;
      case "First Look For Personal Then Professional":
        return EmailPreference.PersonalProfessional;
      case "First Look For Professional Then Personal":
        return EmailPreference.ProfessionalPersonal;
      default:
        return null;
    }
  }

  createEmailCampaignStage() {
    let payloadArray = [];
    payloadArray = [
      {
        stage_name: this.stageFormGroup.value.stepName,
        campaign_id: this.campaign_details["campaign_id"],
        subject: this.stageFormGroup.value.subject,
        body: this.stageFormGroup.value.body + `${(this.stageFormGroup.value.isUnsubscribed) ? this.UnsubscribeTextEmailBody : ''}` + '<img src="{{tracker}}">',
        allow_unsubscription: this.stageFormGroup.value.isUnsubscribed,
        regular_days:
          this.stageFormGroup.value.regularDays == "true" ||
          this.stageFormGroup.value.regularDays == true
            ? true
            : false,
        created_by: this.stageFormGroup.value.created_by,
        is_active: true,
        created_on: this.stageFormGroup.value.created_on,
        updated_on: this.stageFormGroup.value.updated_on,
        after_minutes: moment
          .duration(this.stageFormGroup.value.after_minutes, "d")
          .asMinutes(),
        after_id: this.prevStageId,
      },
    ];

    this.campaignService
      .createStage(this.campaign_details["campaign_id"], payloadArray)
      .subscribe(
        (response: any) => {
          if (response.status == "success") {
            this.successMessage = "Stage Created Successfully";
            setTimeout(() => (this.successMessage = ""), 3000);
            this.updateStageObject(response.data[0]);
            if (response.data[0].campaign_stage_id) {
              const updateOrCreateData: Partial<CampaignStagePrompt> = {
                prompt_id: this.aiPromptData.prompt_id as number,
                prompt_input: this.aiPromptData.promptType === 'JD' ? 'JD' : 'Role',
                prompt_value: this.aiPromptData.promptType === 'JD' ? this.aiPromptData.jd : this.aiPromptData.role,
                tone: this.aiPromptData.tone
              };
              this.emailCampaignService.createCampaignStagePrompt(this.campaign_details.campaign_id, response.data[0].campaign_stage_id, [updateOrCreateData]).subscribe(() => {});
            }
            // this.setEditMode();
          }
        },
        (error) => {
          this.errorMessage = "Error creating stage";
          setTimeout(() => (this.errorMessage = ""), 3000);
          console.error("Error creating stage:", error);
        }
      );
    // this.updateCampaign();
  }
  updateCampaignStage(id) {
    let payloadArray = [];
    payloadArray = [
      {
        stage_name: this.stageFormGroup.value.stepName,
        campaign_id: this.campaign_details["campaign_id"],
        subject: this.stageFormGroup.value.subject,
        body: this.stageFormGroup.value.body + `${(this.stageFormGroup.value.isUnsubscribed) ? this.UnsubscribeTextEmailBody : ''}` + '<img src="{{tracker}}">',
        allow_unsubscription: this.stageFormGroup.value.isUnsubscribed,
        regular_days:
          this.stageFormGroup.value.regularDays == "true" ||
          this.stageFormGroup.value.regularDays == true
            ? true
            : false,
        created_by: this.stageFormGroup.value.created_by,
        is_active: true,
        created_on: this.stageFormGroup.value.created_on,
        updated_on: this.stageFormGroup.value.updated_on,
        after_minutes: moment
          .duration(this.stageFormGroup.value.after_minutes, "d")
          .asMinutes(),
        after_id: this.prevStageId,
      },
    ];
    this.campaignService
      .updateStage(id, this.stage.campaign_stage_id, payloadArray[0])
      .subscribe(
        (res: any) => {
          if (res.status == "success")
            this.successMessage = "Stage updated Successfully";
          setTimeout(() => (this.successMessage = ""), 3000);
          this.updateStageObject(res.data);
        },
        (error) => {
          this.errorMessage = "Error while  updating stage";
          setTimeout(() => (this.errorMessage = ""), 3000);
          console.error("Error updating stage:", error);
        }
      );
  }
  updateCampaign(status) {
    const schedule =
      this.stageFormGroup.value.schedule.startTime &&
      !this.stageFormGroup.value.schedule.startTime.includes("null") &&
      this.stageFormGroup.value.schedule.startTime !== null &&
      this.stageFormGroup.value.schedule.endTime &&
      !this.stageFormGroup.value.schedule.endTime.includes("null") &&
      this.stageFormGroup.value.schedule.startTime != null
        ? this.stageFormGroup.value.schedule.startTime +
          "-" +
          this.stageFormGroup.value.schedule.endTime
        : "10:00-17:00";
    const payloadObject = {
      campaign_id: this.campaign_details["campaign_id"],
      status: status === 1 ? CampaignStatus.Active : CampaignStatus.Draft,
      timezone: this.stageFormGroup.value.schedule.timezone,
      schedule: schedule,
      updatedon: new Date().toISOString(),
      email_pref: this.stageFormGroup.value.to,
      useremailintegrationid: this.stageFormGroup.value.from,
    };
    this.campaignService.updateCampaign(payloadObject).subscribe(
      (res: any) => {
        this.successMessage = "Stage updated Successfully";
        setTimeout(() => (this.successMessage = ""), 3000);
        this.isEditMode.emit({
          stageId: this.stage.campaign_stage_id,
          editMode: false,
        });
        this.updateCampaignObject({
          timezone: res.data.timezone,
          email_pref: res.data.email_pref,
          schedule: res.data.schedule,
          useremailintegrationid: res.data.useremailintegrationid,
        });
      },
      (error) => {
        this.errorMessage = "Error updating stage";
        setTimeout(() => (this.errorMessage = ""), 3000);
        console.error("Error updating stage:", error);
      }
    );
  }
  fetchIntegration() {
    this.emailintegrationservice
      .fetchintegratedemails()
      .pipe(
        map((data: any) => {
          if (data && data.status == "success") {
            if (
              data.integratedemailsarray &&
              data.integratedemailsarray.length
            ) {
              data.integratedemailsarray = data.integratedemailsarray.map((x) =>
                Object.assign(x, {
                  useremailintegrationid: parseInt(atob(x.userintegrationid)),
                })
              );
            }
          }
          return data;
        })
      )
      .subscribe((res: any) => {
        if (res.status == "success") {
          if (res.integratedemailsarray && res.integratedemailsarray.length) {
            this.integratedemailsarray = this.integratedemailsarray;
            this.integratedemailsarray = res.integratedemailsarray;
            if (
              this.campaign_details &&
              !this.campaign_details["useremailintegrationid"]
            )
              this.stageFormGroup.patchValue({
                from: this.integratedemailsarray[0]["useremailintegrationid"],
              });
            else
              this.stageFormGroup.patchValue({
                from: this.campaign_details["useremailintegrationid"],
              });
          }
        } else {
          //console.log("error Fetching emails");
        }
      });
  }
  getEmailTemplate() {
    this.emailsettings
      .getallEmailTemplate(this._localstorageservice.getItem("usernumber"))
      .subscribe((res: any) => {
        if (res.status == "success") {
          this.customtempList = res.message;
        } else {
        }
      });
  }

  selectedTemplateOption(event: any) {
    this.emailsettings
      .getEmailDetails(
        event.target.value,
        this._localstorageservice.getItem("usernumber")
      )
      .subscribe((res: any) => {
        if (res.status == "success") {
          this.stageFormGroup.patchValue({
            subject: res.message[0].subject,
            body: res.message[0].template,
          });
        } else {
          //console.log("Something went Wrong")
        }
      });
  }
  getCursorPosition(type) {
    this.InputtoEdit = type;
    this.sel = window.getSelection();
    if (this.sel.getRangeAt && this.sel.rangeCount) {
      this.range = this.sel.getRangeAt(0);

      this.placeid = true;
    }
  }
  //Placeholder
  selectplaceholder(event: any) {
    this.dropDownValue = event.target.value;
    if (this.range) {
      if (this.InputtoEdit == "body") {
        if (this.bodyEditor) {
          this.bodyEditor.focus();
          if (this.bodyEditor.hasFocus()) {
            const range = this.bodyEditor.getSelection();
            if (range && range.length === 0) {
              const insertText = "{{ " + this.dropDownValue + " }}";
              this.bodyEditor.insertText(range.index, insertText);
              const index = this.bodyEditor.getSelection().index;
              setTimeout(() => {
                this.bodyEditor.focus();
                this.dropDownValue = "";
                // this.placeid = false;
                this.stageFormGroup.patchValue({
                  body: this.bodyEditor.root.innerHTML,
                });
                this.bodyEditor.setSelection(index, 0);
              }, 0);
            }
          }
        }
      } else if (this.InputtoEdit == "subject") {
        var startPos = this.subject.nativeElement.selectionStart;
        this.subject.nativeElement.focus();
        this.subject.nativeElement.value =
          this.subject.nativeElement.value.substr(
            0,
            this.subject.nativeElement.selectionStart
          ) +
          "{{" +
          this.dropDownValue +
          "}}" +
          this.subject.nativeElement.value.substr(
            this.subject.nativeElement.selectionStart,
            this.subject.nativeElement.value.length
          );
        this.subject.nativeElement.selectionStart = startPos;
        this.subject.nativeElement.setSelectionRange(
          startPos + this.dropDownValue.length + 4,
          startPos + this.dropDownValue.length + 4
        );
        this.stageFormGroup.patchValue({
          subject: this.subject.nativeElement.value,
        });
      }
    }
    this.stageFormGroup.patchValue({
      placeholder: "",
    });
    this.dropDownValue = "";
    this.placeid = false;
  }
  setEndOfContenteditable(contentEditableElement) {
    var range, selection;
    if (document.createRange) {
      //Firefox, Chrome, Opera, Safari, IE 9+
      range = document.createRange(); //Create a range (a range is a like the selection but invisible)
      range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
      range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
      selection = window.getSelection(); //get the selection object (allows you to change selection)
      selection.removeAllRanges(); //remove any selections already made
      selection.addRange(range); //make the range you have just created the visible selection
    }
  }
  createTemplate() {
    if (this.modalData.templateName && !this.modalData.templateName.length) {
      return;
    }
    if (
      this.saveAsTemplate &&
      this.modalData.templateName &&
      this.modalData.templateName.length
    ) {
      let data = {
        template: {
          userid: this._localstorageservice.getItem("usernumber"),
          action: this.modalData.templateName,
          actionname: this.modalData.templateName,
          template: this.stageFormGroup.value.body,
          subject: this.stageFormGroup.value.subject,
          description: "desc",
          type: "custom",
          createdby: this._localstorageservice.getItem("usernumber"),
          updatedby: this._localstorageservice.getItem("usernumber"),
        },
        activitylog: [
          {
            action: "'create'",
            tablename: "'emailtemplates'",
            newvalue: "'new'",
            type: "'custom'",
            usertype: "'create'",
            createdby:
              "'" + this._localstorageservice.getItem("usernumber") + "'",
            userid: "'" + this._localstorageservice.getItem("usernumber") + "'",
          },
        ],
      };
      this.emailsettings.createCustomEmail(data).subscribe((res) => {
        if (res["status"] == "success") {
          this.closeModal();
          this.successMessage = "Template Created Successfully";
          this.modalData.templateName = "";
          setTimeout(() => (this.successMessage = ""), 3000);
        } else {
          this.errorMessage = "Error while creating template";
          this.modalData.templateName = "";
          setTimeout(() => (this.errorMessage = ""), 3000);
        }
      });
    }
  }
  closeModal() {
    this.saveAsTemplate = false;
    this.modalData.templateName = "";
    this.modalRef.dismiss();
  }
  /**
   * Calculates difference in minutes between two times
   * @param time1
   * @param time2
   * @returns
   */
  differenceInMinutes(time1: string, time2: string): number {
    const [hours1, minutes1] = time1.split(":");
    const [hours2, minutes2] = time2.split(":");
    const hoursDiff = Number(hours2) - Number(hours1);
    const minutesDiff = Number(minutes2) - Number(minutes1);
    const minDiff = hoursDiff * 60 + minutesDiff;
    return minDiff;
  }

  performDateValidation(startDate: string, startTime: string, endTime: string) {
    if (startDate && startTime && endTime) {
      this.stageFormGroup.get("schedule").get("startTime")?.setErrors(null);
      this.stageFormGroup.get("schedule").get("endTime").setErrors(null);
      const minDiff = this.differenceInMinutes(startTime, endTime);
      if (minDiff < 0) {
        return {
          invalid: true,
          message: "Start time should be smaller than end time.",
        };
      }

      return null;
    }
    return null;
  }

  // isEditMode(formIndex: number): boolean {
  // Assuming you have an array of edit modes corresponding to each form
  // return this.sharedService.getEditMode(formIndex);
  // }
  getFromValue(integrationid) {
    return this.integratedemailsarray.find(
      (x) => x.useremailintegrationid == integrationid
    )?.emailid;
  }
  isStageActive(stageId: number) {
    return stageId === this.activeStage;
  }
  setEditMode() {
    // this.isEditing = !this.isEditing;
    this.isEditMode.emit({
      stageId: this.stage.campaign_stage_id,
      editMode: !this.isInEditMode.editMode,
    });
  }
  updateStageObject(stageObj) {
    this.updatedStage.emit({
      campaign_stage_id: stageObj.campaign_stage_id,
      campaign_id: stageObj.campaign_id,
      stage_name: stageObj.stage_name,
      subject: stageObj.subject,
      body: stageObj.body,
      created_on: stageObj.created_on,
      after_id: stageObj.after_id,
      updated_on: stageObj.updated_on,
      after_minutes: stageObj.after_minutes,
      regular_days: stageObj.regular_days,
      created_by: this.stage.created_by,
      is_active: this.stage.is_active,
      isUnsubscribed: stageObj.allow_unsubscription
    });
  }
  get hasStages() {
    return this.stages && this.stages.length;
  }

  updateCampaignObject(campaignObj) {
    this.updatedCampaign.emit({
      ...this.campaign_details,
      schedule: campaignObj.schedule,
      timezone: campaignObj.timezone,
      email_pref: campaignObj.email_pref,
      useremailintegrationid: campaignObj.useremailintegrationid,
    });
  }
  get IsChecked() {
    return this.saveAsTemplate == true;
  }
  toggleSaveAsTemplate(event) {
    this.saveAsTemplate = event.target.value;
    return this.saveAsTemplate;
  }

  getSchedule(schedule) {
    if (
      schedule != null ||
      schedule != undefined ||
      (schedule && !schedule.includes("null"))
    ) {
      return schedule;
    } else return "10:00-17:00";
  }
  resetForm() {
    // Mark all controls as untouched
    Object.keys(this.stageFormGroup.controls).forEach((controlName) => {
      const control = this.stageFormGroup.get(controlName);
      control.markAsUntouched();
    });
  }

  renderPills(data: string, type: string) {
    if (data && data.length) {
      const temp =
        '<span class="rendered-string">' +
        data
          .replace(/\{\{/g, '<span  class="email-campaign-pill">')
          .replace(/\}\}/g, "</span>") +
        "</span>" + `${(type === 'body') && (this.stageFormGroup.controls.isUnsubscribed.value) ? this.UnsubscribeTextEmailBody : ''}`;
      return temp;
    }
  }



  composeManually() {
    this.showAIAssist = false;
    this.composeType = 'MANUAL';
    if (this.bodyEditor) {
      this.bodyEditor.root.dataset.placeholder = "Hello candidate.firstname this is regarding........";
      this.bodyEditor.focus();
    }
  }

  composeAI() {
    this.showAIAssist = true;
    this.composeType = 'AI';
    if (this.bodyEditor) {
      this.bodyEditor.root.dataset.placeholder = "";
    }
  }

  showAIAssistModal() {
    const modalRef = this.modalService.open(EmailCampaignAssistantComponent, { size: 'md', centered: true });
    const instance: EmailCampaignAssistantComponent = modalRef.componentInstance;
    instance.isModal = true;
    if (this.aiPromptData) {
      instance.data = this.aiPromptData;
    }
    // populate ladder with the previous stage content
    instance.ladder = this.stages.filter(s => s.campaign_stage_id !== this.stage.campaign_stage_id && s.campaign_stage_id && s.campaign_stage_id < Math.max(this.stage.campaign_stage_id || 0, 0)).map(s => s.body);
    modalRef.result.then((data: EmailCampaignAssistantData) => {
      if (data) {
        const updateOrCreateData: Partial<CampaignStagePrompt> = {
          prompt_id: data.prompt_id as number,
          prompt_input: data.promptType === 'JD' ? 'JD' : 'Role',
          prompt_value: data.promptType === 'JD' ? data.jd : data.role,
          tone: data.tone
        };
        // update the data in server
        if (this.stage.campaign_stage_id) {
          if (data.id) {
            this.emailCampaignService.updateCampaignStagePrompt(this.campaign_details.campaign_id, this.stage.campaign_stage_id, this.aiPromptData.id, { ...updateOrCreateData, campaign_stage_prompt_id: data.id }).subscribe(() => {});
          } else {
            this.emailCampaignService.createCampaignStagePrompt(this.campaign_details.campaign_id, this.stage.campaign_stage_id, [updateOrCreateData]).subscribe(() => {});
          }
        }
        if (data.response && typeof data.response === 'object' && data.response.subject && data.response.body) {
          this.composeType = 'AI';
          this.stageFormGroup.patchValue({
            subject: data.response.subject,
            body: data.response.body,
          });
        }
        delete data.response;
        this.aiPromptData = data;
        this.showAIAssist = false;
      }
    }).catch(() => {});
  }


  public openTestEmailConfirmationModal() {
    this.modalRef = this.modalService.open(this.testMailConfirmation, {
      size: "md",
      centered: true,
    });
  }

  /**
   * Sends a test email using the provided email settings.
   */
  public sendTestEmail(): void {
    if (this.isSendingTestEmail) return;
    this._isSendingTestEmail = true;
    this.testEmailSent = false;
    this.emailsettings.sendTestEmail({
      recipient: [this.getFromValue(this.campaign_details.useremailintegrationid)],
      subject: "[TEST] " + this.stage.subject.replace(/'/g, "''"),
      body: this.stage.body.replace(/'/g, "''"),
      replacements: {
        candidate: {
          firstname: "Test",
          lastname: "Candidate",
          currentjobtitle: "Test Job Title",
          currentcompany: "Test Company",
          currentlocation: "Test Location",
        },
        user: {
          firstname: "Test",
          lastname: "User",
          email: "test@example.com",
        }
      },
    }).subscribe(() => {
      this._isSendingTestEmail = false;
      this.testEmailSent = true;
      setTimeout(() => {
        this.testEmailSent = false;
      }, 3000);
    });
  }


}
